import {
    useTooltipContentStyles,
} from 'app/shared-components/Tooltip'
import useStyles from './TooltipContent.styles'

const TooltipContentDeliveryService = () => {
    const {
        classes,
        cx,
    } = useStyles()
    const {
        classes: sharedTooltipClasses,
    } = useTooltipContentStyles()

    return (
        <div className={classes.container}>
            <div className={classes.textContainer}>
                <div className={classes.headerContainer}>
                    <div className={classes.listIndicator} />
                    <span className={sharedTooltipClasses.header}>Delivery By Road (SkyCell)</span>
                </div>
                <span className={cx(sharedTooltipClasses.paragraph, classes.paragraph)}>
                    SkyCell delivers the container via road to a Handover location.
                    The following options are available: FTL only,
                    FTL or LTL (both options), LTL only.
                </span>
            </div>
            <div className={classes.textContainer}>
                <div className={classes.headerContainer}>
                    <div className={classes.listIndicator} />
                    <span className={sharedTooltipClasses.header}>Pick-up (Customer)</span>
                </div>
                <span className={cx(sharedTooltipClasses.paragraph, classes.paragraph)}>
                    The customer picks-up the container from a SkyCell
                    Service Center or a Consignment stock.
                </span>
            </div>
        </div>
    )
}

export default TooltipContentDeliveryService
